// A package page's *What it needs* (keepr-api KPR-1809, KPR-1811; plan v4
// §5.12): each of the bundle's cards that can use a card you have, with the
// elements it needs, above What's inside. Said before anything is added, so a
// person whose collection already keeps that kind of record knows the bundle
// can use their card instead of adding a second one.
import React from 'react';

import GroupHeader from '../common/GroupHeader';
import RecordBadge from '../common/RecordBadge';
import { contractWords, requirementsOfPackage } from '../../utils/packageBindings';

export default function PackageNeeds({ pkg, addOnByKey }) {
	// A card another package brings (`provided`) is the Needs list's (KPR-1830).
	const needs = requirementsOfPackage(pkg).filter(r => r.kind !== 'provided');
	if (!needs.length) return null;
	return (
		<section className="package-page__section" aria-label="What it needs">
			<GroupHeader as="h2" label="What it needs" count={needs.length} countLabel="card" />
			<p className="meta-line package-page__needs-note">If the collection you add it to already keeps these, it can use your card instead of adding its own.</p>
			{needs.map((r) => {
				const addOn = r.card.addOn ? addOnByKey?.get(r.card.addOn) : null;
				return (
					<div key={r.card.localId || r.key} className="package-page__card package-page__need">
						<RecordBadge kind="card" record={r.card} title={r.card.name} size="sm" />
						<p className="meta-line package-page__need-line">
							{`Can use a card you have${addOn ? `, with the ${addOn.name} add-on` : ''}. It needs ${contractWords(r.contract) || 'nothing of it'}.`}
						</p>
					</div>
				);
			})}
		</section>
	);
}
